import { useSelector } from 'react-redux';
import { usePlusFeature } from '@browsing/plus';

import { useCustomer } from '@client/hooks';
import { getPlus } from '@client/redux/modules/customer';

export const useZalandoPlus = () => {
    const { isEnabled, isSignupEnabled } = usePlusFeature();

    const plus = useSelector(getPlus);

    useCustomer();

    return { isEnabled, isSignupEnabled, ...plus };
};
